import React from 'react';
import PropTypes from 'prop-types';

function LoadingIndicator(props) {
  const { className } = props;
  const circleCommonClasses = 'h-2.5 w-2.5 bg-blue-400 rounded-full';

  return (
    <div className={`${className || 'flex'}`}>
      <div className={`${circleCommonClasses} mr-1 animate-bounce`} />
      <div
        className={`${circleCommonClasses} mr-1 animate-bounce200`}
      />
      <div className={`${circleCommonClasses} animate-bounce400`} />
    </div>
  );
}

LoadingIndicator.propTypes = {
  className: PropTypes.string,
};

export default LoadingIndicator;
